/**
 * Canonical rule for the professor's Sinclair email address.
 *
 * Students identify their section with their instructor's Sinclair email
 * instead of a class code, so the rule lives here in `packages/shared` and is
 * imported by both the front-end and the service. The rule is deliberately
 * narrow: one non-empty local part followed by the exact `sinclair.edu` domain,
 * compared case-insensitively after trimming.
 */

const SINCLAIR_EMAIL_PATTERN = /^[^@\s]+@sinclair\.edu$/i;

/** True when `email` is a Sinclair address, ignoring case and surrounding whitespace. */
export function isSinclairEmail(email: string): boolean {
  return SINCLAIR_EMAIL_PATTERN.test(email.trim());
}
